import React, {FC, useEffect, useState} from "react";
import "../assets/styles/styles.scss";
import NoticeIcon from "../assets/images/icon_notice.svg";
import MoreIcon from "../assets/images/icon_more.png";
import axios from "axios";
import BoardShortcutPost from "./BoardShortcutPost";
import { useNavigate } from "react-router-dom";

type BoardShortcutProps = {
    title: string;
};

const BoardShortcut: FC<BoardShortcutProps> = ({ title }) => {

    const navigate = useNavigate();

    const goToBoard = () => {
        // 하드코딩으로 추후 작업
        const noticeLink = '/board/11';
        const faqLink = '/board/12';
        const iconLink = title === '공지사항' ? noticeLink : faqLink;

        navigate(iconLink);
    }

    const ScheduleContent = (): JSX.Element => {
        return (
            <div className={'schedule-content-wrapper'}>
                <div className={'schedule-content-body'}>
                    <table className={'schedule-content-table'}>
                        <thead>
                            <tr>
                                <th>회차</th>
                                <th>접수마감일</th>
                                <th>심의일</th>
                                <th>심의건수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>제1차</td>
                                <td>11/20</td>
                                <td>12/3</td>
                                <td>3건</td>
                            </tr>
                            <tr>
                                <td>제2차</td>
                                <td>11/27</td>
                                <td>12/10</td>
                                <td>4건</td>
                            </tr>
                            <tr>
                                <td>제3차</td>
                                <td>12/10</td>
                                <td>12/24</td>
                                <td>3건</td>
                            </tr>
                            <tr>
                                <td>제4차</td>
                                <td>12/24</td>
                                <td>1/8</td>
                                <td>1건</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    return (
        <div className={'board-shortcut-item-wrapper'}>
            <div className={'board-shortcut-item'}>
                <div className={'board-shortcut-item-header'}>
                    <div>
                        {/*<img src={NoticeIcon} alt={`${title} 아이콘`} />*/}
                        <span>{title}</span>
                    </div>
                    <img src={MoreIcon} alt={`${title} 더 보기 아이콘`} onClick={goToBoard} />
                </div>
                <div className={'board-shortcut-item-content'}>
                    { title === '공지사항'
                        ? <BoardShortcutPost ctgId={1} />
                        : <BoardShortcutPost ctgId={2} /> }
                </div>
            </div>
        </div>
    );
}

export default BoardShortcut;
